import { Component, EventEmitter, Input, OnDestroy, Output, TemplateRef, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ItemService } from '@services/item.service';
import { NotificationService } from '@services/notification.service';
import { TestService } from '@services/test.service';
import { WebErrorService } from '@services/webError.service';
import { Subscription } from 'rxjs';
import { customValidationService } from 'src/app/shared/custom.validator';
import { ScoringTypeEnum } from 'src/app/shared/config/questions.config';
import { CollectionService } from '@services/collection.service';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-create-item-group',
  templateUrl: './create-item-group.component.html',
  styleUrls: ['./create-item-group.component.scss']
})
export class CreateItemGroupComponent implements OnDestroy {
  @ViewChild('addItem') addItem: TemplateRef<any>;
  itemGroupForm: FormGroup;
  @Input() testUUID;
  isEdit: boolean = false;
  @Output() itemGroupListData = new EventEmitter<any>();
  itemList: boolean = false;
  createItemSubscription: Subscription;
  public dialogRef: MatDialogRef<CreateItemGroupComponent>
  ScoringTypeEnum = ScoringTypeEnum;
  scoringTypeId: any;

  isStyleGroupShow = false;
  scoringTypes: any;
  styleGroupData: any;
  selectedScoringType: any;
  testScoringTypeId: any;
  globalcollectionuuid: any;
  selectedstyleGroup: any;
  evaluationMode: number;

  constructor(
    private dialog: MatDialog,
    private actRoute: ActivatedRoute,
    private itemService: ItemService,
    private notificationService: NotificationService,
    private webErrorService: WebErrorService,
    private testService: TestService,
    public CollectionService: CollectionService,
  ) {
    this.globalcollectionuuid = JSON.parse(sessionStorage.getItem('defaultcollectionuuid'));
    this.testScoringTypeId = parseInt(sessionStorage.getItem('testScoringTypeId'));
    const userData = JSON.parse(sessionStorage.getItem('currentUser'));
    this.evaluationMode = userData.evaluationmode;

    this.itemGroupForm = new FormGroup({
      itemGroupName: new FormControl('', [Validators.required, Validators.maxLength(120), Validators.pattern(/^[ a-zA-Z.-]+([ ]?[a-z0-9 !#|^*()-_@$!%*?&]){0,}$/), customValidationService.cannotContainSpace]),
      description: new FormControl('', [
        Validators.minLength(1),
        Validators.maxLength(480),
      ]),
      enableQuestionSequencing: new FormControl(false),
      itemGroupId: new FormControl(0),
      scoringTypeId: new FormControl(0, [Validators.required]),
      styleGroupId: new FormControl('')
    })
    this.testService.getStyleGroups(JSON.parse(sessionStorage.defaultcollectionid)).subscribe(data => {
      this.styleGroupData = data.data;
    });

    this.testService.getScoringTypes().subscribe((scoringTypes) => {
      if(this.evaluationMode === 1){
        this.scoringTypes = scoringTypes.items.filter(type => type.scoringTypeId === 1 || type.scoringTypeId === 2);
      } else {
        this.scoringTypes = scoringTypes.items;
      }
    });
  }

  showPopup(data: any, previewData: any) {
    this.testScoringTypeId = parseInt(sessionStorage.getItem('testScoringTypeId'));
    this.isStyleGroupShow = false;
    this.itemList = null;
    if (data) {
      previewData.forEach(e => {
        if (e.itemGroupId === data.itemGroupId) this.itemList = true;
      });

      this.dialog.open(this.addItem, { width: '700px', height: '350px', panelClass: 'dialog-container' });
      this.itemGroupForm.patchValue({
        ...data, description: data.itemGroupDescription,
        itemGroupId: data.itemGroupId, enableQuestionSequencing: data.enableQuestionSequencing,
        scoringTypeId: data.scoringTypeId,
        styleGroupId: ''
      });

      this.selectedScoringType = data.scoringTypeId;
      this.selectedstyleGroup = data.styleGroupId;
      this.isEdit = true;

      if (data.scoringTypeId != null) this.changeScoringType(data.scoringTypeId);

    } else {
      this.itemGroupForm.reset({ itemGroupName: '', description: '', itemGroupId: 0, enableQuestionSequencing: false, scoringTypeId: this.testScoringTypeId, styleGroupId: 0});
      this.dialog.open(this.addItem, { width: '700px', height: '350px', panelClass: 'dialog-container' });
      this.isEdit = false;

      if (this.testScoringTypeId != null) {
        this.selectedScoringType = this.testScoringTypeId;
        this.selectedstyleGroup = '';
        this.changeScoringType(this.testScoringTypeId);
      }
    }
  }

  changeScoringType(event) {
    this.isStyleGroupShow = parseInt(event) == 3 ? true : false;
    const styleGroupId = this.itemGroupForm.get('styleGroupId');

    if (parseInt(event) != 0) {
      if (parseInt(event) === 3) {
        styleGroupId.setValidators([Validators.required]);
      } else {
        styleGroupId.setValue('');
        styleGroupId.setValidators(null);
        styleGroupId.markAsUntouched();
      }
      styleGroupId.updateValueAndValidity();
    }
  }

  closePopup() {
    this.isStyleGroupShow = false;
    this.dialog.closeAll();
  }

  saveItemGroup() {
    this.testUUID = this.testUUID ? this.testUUID : this.actRoute.snapshot.paramMap.get('id');
    if (this.isEdit) {
      const updateItemGroup = this.itemService.updateItemGroup(this.testUUID, this.itemGroupForm.value).subscribe(data => {
        this.notificationService.success(data.message);
        this.itemService.getItemGroupList(this.testUUID).subscribe(data => {
          this.itemGroupListData.emit(data.data);
        })
        this.closePopup();
      }, (error: any) => { this.webErrorService.handleAPIErrors(error, '', true, 'warn'); }, () => { updateItemGroup.unsubscribe() });
    } else {
      this.createItemSubscription = this.itemService.createItemGroup(this.testUUID, this.itemGroupForm.value).subscribe((data) => {
        this.notificationService.success(data.message);
        // this.testService.loadItemGroups.next(true);
        this.itemService.getItemGroupList(this.testUUID).subscribe(data => {
          this.itemGroupListData.emit(data.data);
        });
        this.closePopup();
      }, (error: any) => { this.webErrorService.handleAPIErrors(error, '', true, 'warn'); });
    }
  }

  ngOnDestroy(): void {
    if (this.createItemSubscription) {
      this.createItemSubscription.unsubscribe();
    }
  }
}
